/* eslint-disable linebreak-style */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../stores/types/types';
import SlidingMenu, { SlidingMenuOption } from '../general-components/sliding-menu';
import ContentGeneratorHandler from './settings/content-generator-handler';
import ContentFormProvider from '../../contexts/generated-content/content-form-context';
import ThemeTab from './stylepacks/themes/theme-tab';
import { setEditingTheme } from '../../stores/actions/themes';
import AnimationsTab from './settings/animations/animations-tab';
import { AnimationsProvider } from './settings/animations/animations-context';
import AnimationTabOld from './settings/animations/old-animation-tab/animation-tab-old';

interface Props {
	isForShotEditorModal?: boolean;
	forceHide?: boolean;
}

export const OVERLAY_SETTINGS_TABS = {
	ANIMATION: 0,
	TITLE: 1,
	THEME: 2,
};

const menuOptions: SlidingMenuOption[] = [
	{ label: 'Content', data: { value: OVERLAY_SETTINGS_TABS.TITLE } },
	{ label: 'Theme', data: { value: OVERLAY_SETTINGS_TABS.THEME } },
	{ label: 'Animation', data: { value: OVERLAY_SETTINGS_TABS.ANIMATION } },
];

export default function OverlaysSettings(props: Props) {
	const {
		forceHide = false,
		isForShotEditorModal = false,
	} = props;

	const dispatch = useDispatch();

	const id = useSelector((s: GS) => s.GraphicsReducer.currentGraphicId);
	const shotModalGraphics = useSelector((s: GS) => s.GraphicsReducer.shotModalGraphics);
	const graphics = useSelector((s: GS) => s.GraphicsReducer.graphics);
	const useStylepacks = useSelector((s: GS) => s.SettingsReducer.featureFlags?.use_title_library);
	
	const selectedGraphic = useMemo(() => {
		return isForShotEditorModal
			? shotModalGraphics.find((g) => g.id === id)
			: graphics.find((g) => g.id === id);
	}, [id, shotModalGraphics, graphics]);

	const isGeneratedCont = !!selectedGraphic?.template_type;
	const actualMenuOptions = isGeneratedCont ? menuOptions : [menuOptions[2]];
	// @TODO: at some point this will need to come from a setting, only one tab for now
	const [currentTab, setCurrentTab] = useState(isGeneratedCont ? menuOptions[0] : menuOptions[2]);

	useEffect(() => {
		setCurrentTab(actualMenuOptions[0]);
		dispatch(setEditingTheme(null, false));
	}, [selectedGraphic?.id]);

	if (!selectedGraphic || forceHide) {
		return <>&nbsp;</>;
	}

	return (<>
		<SlidingMenu
			options={actualMenuOptions}
			selectedOption={currentTab ?? menuOptions[0]}
			callback={(o: SlidingMenuOption) => setCurrentTab(o)}
			className="padding-left-small position-relative width-calc-full"
			fullWidthDivider={true}
			dividerClassname='lemonade'
		/>
		<div className="shot-builder-modal-media-container">
		{(isGeneratedCont && useStylepacks) ? <ContentFormProvider isForShotEditorModal={isForShotEditorModal}>
			{currentTab?.data?.value === OVERLAY_SETTINGS_TABS.TITLE ? (
				<ContentGeneratorHandler fieldTypes={['image', 'string', 'duration']}/>
			) : null}
			{currentTab?.data?.value === OVERLAY_SETTINGS_TABS.THEME ? (
				<ThemeTab isForShotEditorModal={isForShotEditorModal}/>
			) : null}
			{currentTab?.data?.value === OVERLAY_SETTINGS_TABS.ANIMATION ? (
				<AnimationsProvider isForShotEditorModal={isForShotEditorModal}>
					<AnimationsTab isForShotEditorModal={isForShotEditorModal} stylepackItem={true}/>
				</AnimationsProvider>
			) : null}
		</ContentFormProvider> 
		: useStylepacks ? <AnimationsProvider isForShotEditorModal={isForShotEditorModal}>
			<AnimationsTab isForShotEditorModal={isForShotEditorModal} stylepackItem={false}/>
		</AnimationsProvider>
		: <AnimationTabOld isForShotEditorModal={isForShotEditorModal} />}
		</div>
	</>);
}
